export function getTemporalId() {
  return ((Date.now() % 10000) * 100) + Math.floor(Math.random() * 100);
}